var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBeard = function SvgBeard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 39,
    height: 41,
    viewBox: "0 0 1.34 1.43",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.76.11C.4 0 .17.31.3.68c.06.17.15.49.29.54.32.11.46-.35.46-.6C1.05.36.99.18.76.11z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.3.59C.23.56-.04.65.05.8.09.87.26.79.14.86c-.1.06-.07.18.11.15.06-.02-.03.04-.02.16.01.06.15.07.18.02.01.01-.05.15.12.21.04.01.13-.04.13-.11 0-.01.1.15.23.08.09-.05 0-.21.03-.19.11.08.21-.03.14-.18-.02-.05.11.07.16-.12.02-.06-.13-.05.01-.07.12-.01.14-.2-.18-.24 0 .02.01.03 0 .05C.87.97.23.7.31.64.32.64.3.61.3.59zm.23.39c0 .19.31.17.32.01C.86.86.53.87.53.98z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.07,
    strokeMiterlimit: 22.9256
  })));
};

export default SvgBeard;